'use client';

import { useEffect } from 'react';
import { captureException } from '@/lib/analytics/posthog';

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    console.error('Global layout error:', error);
    captureException(error, { digest: error.digest });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div style={{ display: 'flex', minHeight: '100dvh', alignItems: 'center', justifyContent: 'center', padding: '1rem' }}>
          <div>
            <h1>Something went wrong</h1>
            <p>An unexpected error occurred. Please refresh the page.</p>
            {error.digest && (
              <p style={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>
                Error ID: {error.digest}
              </p>
            )}
            <button type="button" onClick={reset}>
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
